const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/workForm.vue3.js
// module id = 1208
// module chunks = 41